import { strings } from '../localization';

// convert graphql key to front end filter name, ideally it should be handled in graphql
export const GetFilterName = (key: string): string => {
    switch (key) {
        case 'Directory.TermSessionID':
            return 'Active Term Booking';
        case 'Directory.ApplicationStatusID':
            return 'Application Status';
        case 'EntryApplication.TermID':
            return 'Applied For Term';
        case 'TermSession.TermID':
            return 'Booking For Term';
        case 'Directory.CategoryID':
            return 'Category';
        case 'CommunityFilter':
            return 'Community';
        case 'Directory.EntryStatusEnum':
            return 'Entry Status';
        case 'Directory.GenderEnum':
            return 'Gender';
        case 'Directory.RoomTypeID':
            return 'Room Types';
        case 'Directory.EventID':
            return 'Upcoming Events';
        case 'Directory.GroupID':
            return 'Upcoming Groups';
        default:
            throw new Error(`${key} NOT FOUND`)
    }
};

export const GetCaptionFromViewType = (viewType: starrez.DirectoryViewType | undefined) => {
    switch (viewType) {
        case 'ACTIVE_ENTRIES':
        case 'ALL_ENTRIES':
            return strings.View_Label_ListWithAdvancedFilteringCriteria;
        case 'SAVED_LIST':
            return strings.View_Label_SavedList;
        case 'DYNAMIC_LIST':
            return strings.View_Label_DynamicList;
        default:
            return '';
    }
};
